function isInvalidRefreshTokenMessage(value) {
  const msg = String(value?.message || value || '').toLowerCase();
  return msg.includes('invalid refresh token') || msg.includes('refresh token not found');
}

function isSupabaseAuthLockMessage(value) {
  const msg = String(value?.message || value || '').toLowerCase();
  return msg.includes('auth-token') && (
    msg.includes('another request stole it') ||
    msg.includes('was released') ||
    msg.includes('lock:sb-') ||
    msg.includes('locks:sb-')
  );
}

function clearSupabaseAuthStorage() {
  try {
    Object.keys(localStorage)
      .filter(key => key.startsWith('sb-') && key.endsWith('-auth-token'))
      .forEach(key => localStorage.removeItem(key));
  } catch {
    /* ignore storage access failures */
  }
}

export function installAuthConsoleGuard() {
  if (typeof window === 'undefined') return;
  if (console.error === window.__sitescopeAuthConsoleGuardWrapper) return;

  const originalConsoleError = console.error.bind(console);
  const guardedConsoleError = (...args) => {
    if (args.some(isInvalidRefreshTokenMessage)) {
      clearSupabaseAuthStorage();
      return;
    }
    if (args.some(isSupabaseAuthLockMessage)) {
      console.warn('[SiteScope] Ignored transient Supabase auth lock race.');
      return;
    }
    originalConsoleError(...args);
  };
  window.__sitescopeAuthConsoleGuardWrapper = guardedConsoleError;
  console.error = guardedConsoleError;

  if (!window.__sitescopeAuthRejectionGuard) {
    window.__sitescopeAuthRejectionGuard = true;
    window.addEventListener('unhandledrejection', (event) => {
      if (isInvalidRefreshTokenMessage(event.reason)) {
        clearSupabaseAuthStorage();
        event.preventDefault();
      } else if (isSupabaseAuthLockMessage(event.reason)) {
        console.warn('[SiteScope] Ignored transient Supabase auth lock race.');
        event.preventDefault();
      }
    });
  }
}

installAuthConsoleGuard();
